export default "__VITE_ASSET__CQaNeRm$__"